export default {
  title: "Balans",
  balanceInfo: {
    title: "Balans haqida ma’lumot",
    subtitle:
      "Balansdagi ko‘rsatilgan RC hisobdagi barcha operatsiyalar bo‘yicha hisob-kitoblardan so‘ng kutilyotgan summa hisoblanadi.",
    moreDetailSpoiler: {
      ru: [
        {
          title: "Haqiqiy balans",
          description: [
            {
              type: "text",
              value:
                "Bank orqali balansni to‘ldirish, bekor qilingan operatsiyalar bo‘yicha qaytarishlar, mijozlardan hisobga olingan ballarni o‘z ichiga oladi. Mukofotlarni taqsimlash ssenariylari bo‘yicha ballar to‘lanishi, tarif va xizmatlar bo‘yicha chegirmalar, shuningdek, «To‘lovga ajratilgan» summa (agar belgilangan bo‘lsa) chiqarib tashlangan holda hisoblanadi.",
            },
          ],
        },
        {
          title: "Kiritilishi kutilmoqda",
          description: [
            {
              type: "text",
              value:
                "Hozircha sizning haqiqiy balansingizda yetarli mablag‘ bo‘lmaganligi sababli mijozlardan kelgan ballar hali hisobga olinmagan. Shuningdek, mijozlarning sayohati (siz raqamlashtirgan mijozlar boshqa tashkilotlarni ziyorat qilganda berilgan mukofot) ham kiritilishi kutilmoqda. Kutish holati, agar siz raqamlashtirgan mijoz tashrif buyurgan hamkorning hisobida yetarli mablag‘ bo‘lmasa yuzaga keladi.",
            },
          ],
        },
        {
          title: "Chiqarilishi kutilmoqda",
          description: [
            {
              type: "text",
              value:
                "Hozircha ssenariylar bo‘yicha mukofotlarni taqsimlash amalga oshmagan ballar va agar tashkilotda hisobga olish kechikishi belgilangan bo‘lsa, ular ham hisobga olinadi.",
            },
          ],
        },
        {
          title: "Chiqarishga mavjud",
          description: [
            {
              type: "text",
              value:
                "Haqiqiy balans, chiqishi kutilayotgan mablag‘lar, belgilangan depozit summasi va «To‘lovga ajratilgan» summani (agar belgilangan bo‘lsa) chiqarib tashlagandan keyin qolgan summa.",
            },
          ],
        },
        {
          title: "To‘lovga ajratilgan",
          description: [
            {
              type: "text",
              value: "Hisob-kitob davrida haqiqatan to‘lanadigan summa.",
            },
            {
              type: "text",
              value:
                "Har oy ikki marta balans sozlamalarida belgilangan va 300 RC dan kam bo‘lmagan, «Chiqarishga mavjud» balansdan oshmagan miqdorda o‘rnatiladi. To‘lov miqdorini belgilash uchun balans kartasida «Sozlamalar» tugmasini bosing.",
            },
            {
              type: "text",
              value:
                "Agar hisob-kitobdan oldin summa belgilanmagan bo‘lsa va «Chiqarishga mavjud» summasi bo‘yicha to‘lov yoqilmagan bo‘lsa, to‘lov amalga oshirilmaydi.",
            },
            {
              type: "text",
              value:
                "Balansdan pul chiqarish taxminiy sanalari — har oy 1–5 va 16–20 sanalar oralig‘ida. Hisob-kitobdan keyin hisob raqamlariga to‘lov 14 kun ichida amalga oshiriladi.",
            },
          ],
        },
        {
          title: "Tekshiruv akti",
          description: [
            {
              type: "v-text",
              value:
                "Tekshiruv aktlarini va bajarilgan ishlarni qo‘llab-quvvatlash xizmatidan olishingiz mumkin. Buning uchun RC CITY kabinetidagi pastki o‘ng burchakdagi aloqa formasidan so‘rov yuboring yoki <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a> ga xat yozing.",
            },
            {
              type: "list",
              title: "So‘rovda quyidagilarni ko‘rsatish kerak:",
              list: [
                "STIR",
                "Yuridik shaxs nomi",
                "Tekshiruv akti yoki bajarilgan ishlar summasi kerak bo‘lgan davr",
              ],
            },
          ],
        },
      ],
      noRu: [
        {
          title: "Haqiqiy balans",
          description: [
            {
              type: "text",
              value:
                "Bank orqali balansni to‘ldirish, bekor qilingan operatsiyalar bo‘yicha qaytarishlar va mijozlardan hisobga olingan ballarni o‘z ichiga oladi. Mukofotlarni taqsimlash ssenariylari bo‘yicha ballar va tarif hamda xizmatlar uchun chegirmalar chiqarib tashlanadi.",
            },
          ],
        },
        {
          title: "Kiritilishi kutilmoqda",
          description: [
            {
              type: "text",
              value:
                "Hozircha sizning haqiqiy balansingizda yetarli mablag‘ bo‘lmaganligi sababli mijozlardan kelgan ballar hisobga olinmagan. Shuningdek, mijozlarning sayohati (siz raqamlashtirgan mijozlar boshqa tashkilotlarni ziyorat qilganda berilgan mukofot) ham kiritilishi kutilmoqda.",
            },
          ],
        },
        {
          title: "Chiqarilishi kutilmoqda",
          description: [
            {
              type: "text",
              value:
                "Hozircha ssenariylar bo‘yicha mukofotlarni taqsimlash amalga oshmagan ballar va agar tashkilotda hisobga olish kechikishi belgilangan bo‘lsa, ular ham hisobga olinadi.",
            },
          ],
        },
        {
          title: "Chiqarishga mavjud",
          description: [
            {
              type: "text",
              value:
                "Haqiqiy balans, chiqishi kutilayotgan mablag‘lar va belgilangan depozit summasini chiqarib tashlagandan keyin qolgan summa.",
            },
          ],
        },
        {
          title: "Tekshiruv akti",
          description: [
            {
              type: "v-text",
              value:
                "Tekshiruv aktlarini va bajarilgan ishlarni qo‘llab-quvvatlash xizmatidan olishingiz mumkin. Buning uchun RC CITY kabinetidagi pastki o‘ng burchakdagi aloqa formasidan so‘rov yuboring yoki <a class='spoiler-link' href='mailto:hello@rc.city'>hello@rc.city</a> ga xat yozing.",
            },
            {
              type: "list",
              title: "So‘rovda quyidagilarni ko‘rsatish kerak:",
              list: [
                "STIR",
                "Yuridik shaxs nomi",
                "Tekshiruv akti yoki bajarilgan ishlar summasi kerak bo‘lgan davr",
              ],
            },
          ],
        },
      ],
    },
  },
  aboutChapter: {
    title: "Bo‘lim haqida ma’lumot",
    description: [
      "Balans o‘zaro hisob-kitob davrida sizga to‘lanadigan mablag‘laringiz haqidagi ma’lumotni aks ettiradi.",
      "Shuningdek, balans sahifasida uning to‘liq tafsiloti keltirilgan bo‘lib, bu sizga moliyalaringizni yanada samarali nazorat qilish va mablag‘laringizning joriy holatini tushunishga yordam beradi.",
    ],
  },
  withdrawalInstructionName:
    "RC CITY kabinetidan mablag‘ni chiqarish bo‘yicha ko‘rsatma",
  reservedForPayment: "To‘lovga ajratilgan",
  withdrawalOfFund: "Mablag‘ni chiqarish",
  power: {
    on: "Yo‘qilgan",
    off: "O‘chirildi",
  },
  actualBalance: "Haqiqiy balans",
  expectedCredited: "Kiritilishi kutilmoqda",
  expectedDebiting: "Chiqarilishi kutilmoqda",
  availableWithdrawal: "Chiqarishga mavjud",
  statusText: {
    needAdjustPaymentMethod:
      "Mablag‘ni chiqarish uchun to‘lov usulini sozlash kerak",
    bySumReservedOnBalance: "To‘lovga ajratilgan balans summasi bo‘yicha",
    bySumAvailableToWithdrawal:
      "Balansdagi «Chiqarishga mavjud» summa bo‘yicha",
  },
  topupModal: {
    title: "To‘ldirish summasini kiriting",
    entityPayer: "To‘lovchi yuridik shaxs",
    topupSum: "To‘ldirish summasi",
  },
  createAndDownloadAccount: "Hisob-fakturani shakllantirish va yuklab olish",

  byReservedSum: "“To‘lov uchun ajratilgan” summasi bo‘yicha",
  byAvailableSum: "“Chiqarish uchun mavjud” summasi bo‘yicha",
  bySettedSum: "Belgilangаn summa bo‘yicha",
  bySettedSumDesc:
    "Mablag‘lar to‘lov amalga oshirilgunga qadar rezervda bo‘ladi, ularni tarif yoki xizmatlarni xarid qilish uchun ishlatib bo‘lmaydi, chunki haqiqiy balans belgilangаn qiymatga kamayadi. Ushbu usul “Chiqarish uchun mavjud” summasi 300 RC dan kam bo‘lganda mavjud emas.",
  byAvailableSumDesc:
    "To‘lov, hisob-kitoblar amalga oshirilayotgan paytda “Chiqarish uchun mavjud” balans qiymatiga teng miqdorda amalga oshiriladi, agar u 300 RC dan kam bo‘lmasa.",
  success: "Muvaffaqiyatli",
  settings: {
    title: "Pul yechish sozlamalari",
    banner: {
      inProgress: {
        title: "To‘lovlar amalga oshirilmoqda",
        description: [
          "To‘lovlar davrida pul yechish sozlamalarini o‘zgartirish mumkin emas.",
          "Keyingi to‘lov uchun sozlamalarni joriy to‘lov jarayoni tugagandan so‘ng o‘rnatish mumkin bo‘ladi.",
        ],
      },
      inPending: {
        title: "To‘lov kutilmoqda",
        description: [
          "To‘lov shartnomaning 4.6-bandiga muvofiq amalga oshiriladi. Hisobdan yechishning taxminiy sanalari — har oyning 1–5 va 16–20 kunlari. Hisob raqamlariga to‘lov balansdan yechilgan sanadan boshlab 14 kun ichida amalga oshiriladi.",
          "To‘lovni bekor qilish, usulni o‘zgartirish yoki boshqa summani o‘rnatish uchun “Pul yechishni o‘chirish” tugmasini bosing.",
        ],
      },
      inDisabled: {
        title: "Pul yechish o‘chirilgan",
        description: [
          "Pul yechish uchun to‘lov usulini tanlang va sozlamalarni qo‘llang. To‘lov shartnomaning 4.6-bandiga muvofiq amalga oshiriladi.",
          "Hisobdan yechishning taxminiy sanalari — har oyning 1–5 va 16–20 kunlari. Hisob raqamlariga to‘lov balansdan yechilgan sanadan boshlab 14 kun ichida amalga oshiriladi.",
          "Hech narsa tanlanmasa, ushbu yuridik shaxs uchun to‘lov belgilangan davrda amalga oshirilmaydi.",
        ],
      },
    },
    paymentMethod: "To‘lov usuli",
    sumToBePaid: "To‘lanadigan summa",
    validSumTobePaidValid:
      "Eng kamida 300 RC va “Chiqarish uchun mavjud” balans qiymatidan oshmagan miqdorni o‘rnatish mumkin",
    entity: "Yuridik shaxs",
    notSelectedNoPayment: "Tanlanmagan, to‘lov amalga oshirilmaydi",
    bank: {
      BIC: "Bank BIK kodi",
      naming: "Bank nomi",
      paymentAccount: "Hisob raqami",
      corpAccount: "Korporativ hisob",
      depositAmount: "Depozit summasi",
      depositAmountHint:
        "Hisobdagi minimal qoldiq. Pul yechilganda balansda qoladigan summa.",
      changeDetails: "Rekvizitlarni o‘zgartirish",
    },
    disableWithdrawal: "Pul yechishni o‘chirish",
    disabledWithdrawalForDefinEntity:
      "{entityName} yuridik shaxsi uchun pul yechish o‘chirilgan",
  },
  editPaymentModal: {
    title: "Bank ma’lumotlarini yoki depozit summasini o‘zgartirmoqchimisiz?",
    subtitle:
      "Tahrirlash uchun siz “Yuridik shaxslar” bo‘limiga o‘tasiz. O‘zgartirishlar kiritilgandan so‘ng, yangi ma’lumotlar asosida pul yechish sozlamalarini o‘rnatish uchun “Balans” sahifasiga qayting.",
    toEdit: "Tahrirlashga o‘tish",
  },
  resetPaymentModal: {
    title: "Pul yechish sozlamalarini bekor qilasizmi?",
    subTitle:
      "“Ha, bekor qilish” tugmasini bosganingizda, pul yechish sozlamalari tiklanadi. Ushbu yuridik shaxs uchun to‘lov amalga oshirilmaydi.",
    yesCancel: "Ha, bekor qilish",
  },
  disabledPaymentModal: {
    title: "Pul yechishni o‘chirishni tasdiqlang",
    subtitle: {
      withFullWithdrawal: [
        "“Tasdiqlash” tugmasini bosganingizda, avval o‘rnatilgan to‘lov summasi rezervdan olinadi. Shundan so‘ng siz to‘lov usulini o‘zgartirishingiz yoki yangi summani o‘rnatishingiz mumkin.",
        "Agar yangi to‘lov usuli tanlanmasa, ushbu yuridik shaxs uchun to‘lov amalga oshirilmaydi.",
        "Muhim! Yangi to‘lov summasini o‘rnatish faqat “Chiqarish uchun mavjud” balans doirasida mumkin bo‘ladi, u rezerv bekor qilingandan keyin o‘zgarishi mumkin.",
      ],
      withoutFullWithdrawal: [
        "O‘chirib bo‘lgach, uni qayta yoqish yoki boshqa to‘lov usulini tanlash mumkin bo‘ladi.",
        "Agar yangi to‘lov usuli tanlanmasa, ushbu yuridik shaxs uchun to‘lov amalga oshirilmaydi.",
      ],
    },
  },
  errorCard: {
    title: "Qarzni to‘lang",
    description:
      "Hisob-fakturani elektron pochtangizga yuborilgan shaklda yuklab oling va to‘lang yoki «To‘ldirish» tugmasini bosib uni mustaqil ravishda yarating.",
  },
};
